import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { Backdrop, CircularProgress, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link as DomLink } from 'react-router-dom';

interface Props {
  profilePath: string;
  logoutPath: string;
}

const AuthenticatedOptions = (props: Props) => {
  const { profilePath, logoutPath } = props;
  const [loading, setLoading] = useState<boolean>(false);

  return (<>
    {
      loading ?
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, display: 'flex', flexDirection: 'column' }}
          open={true}
        >
          <CircularProgress color="inherit" />
          <Typography variant="h5" gutterBottom component="div">
            Orbiting satellites...
          </Typography>
        </Backdrop>
        : <></>
    }
    <ListItem component={DomLink} to={profilePath} onClick={() => setLoading(true)}>
      <ListItemIcon>
        <PersonIcon />
      </ListItemIcon>
      <ListItemText>
        Profile
      </ListItemText>
    </ListItem>
    <ListItem component={DomLink} to={logoutPath} onClick={() => setLoading(true)}>
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText>
        Logout
      </ListItemText>
    </ListItem>
  </>);
}

export default AuthenticatedOptions;
